import { Mappable } from "../../../_shared/mappable.class";
import { PledgePerWin } from "./PledgePerWin";

export class Game extends Mappable<Game> {
    pledgePerWinGameId: number;
    pledgePerWinId: number;
    pledgePerWin: PledgePerWin;
    name: string;
    dateCompleted: Date;
    message: string;
    chargeCount: number;
    status: GameStatus;
    totalRaised: number;
}

export enum GameStatus {
    Completed = 1,
    Reversed = 2
}

export class GameGroup {
    group: string;
    children: Game[];
}